import { useEffect, useState, useContext } from "react";
import styles from "../CreateAdminUser/CreateAdminUserModal.module.css";
import {FaChevronDown} from "react-icons/fa";
import {formatPhone} from "../../../utils/PhoneUtils";
import {insertMasterUser} from "../../../hooks/User";
import {UserContext} from '../../../context/UserContext';
import {getClients} from "../../../data/clients/repository/ClientsRepository";

function Modal({ closeModal }) {
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [access, setAccess] = useState("");
  const [clients, setClients] = useState([]);
  const [clientId, setClientId] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [isUserRoleDropdownOpen, setIsUserRoleDropdownOpen] = useState(false);
  const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false);
  const [selectedUserRole, setSelectedUserRole] = useState("Selecione a função do usuário");
  const [selectedClient, setSelectedClient] = useState("Selecione o cliente");
  const {addUser} = useContext(UserContext);
  
  const toggleUserRoleDropdown = () => { setIsUserRoleDropdownOpen(!isUserRoleDropdownOpen) };
  const toggleClientDropdown = () => { setIsClientDropdownOpen(!isClientDropdownOpen) };
  const handleUserRoleSelect = ( role ) => {
    setSelectedUserRole(role);
    switch ( role ) {
      case "Master/Admin":
        setRole("MASTER")
        setAccess("PANEL_ADMIN_ACCESS")
        break;
      default:
        setRole("")
        break;
    }
  };

  const handleToggleClientSelection = ( client ) => {
    setSelectedClients(( prevSelectedClients ) => {
      if (prevSelectedClients.some((c) => c.id === client.id)) {
        return prevSelectedClients.filter((c) => c.id !== client.id);
      } else {
        return [...prevSelectedClients, client];
      }
    });
  };
  
  const handleSelectClient = ( client ) => {
    setSelectedClient(client.name);
    setClientId(client.id);
  };

  useEffect(() => {
    const fetchClients = async () => {
      const clientData = await getClients();
      if (clientData) {
        setClients(clientData?.clients ?? []);
      }
    };
    fetchClients();
  },[]);

  const handlePhoneChange = (e) => {
    const rawValue = e.target.value;
    const formattedPhone = formatPhone(rawValue);
    setPhone(formattedPhone);
  };

  const handleSaveUser = async () => {
    const userData = { 
      name, 
      username, 
      password, 
      phone, 
      role, 
      access,
  };
    const response = await insertMasterUser(clientId, userData);
    if (response) {
      addUser(true)
      closeModal();
    } else {
      addUser(false)
    }
  };

  const renderDropdown = () => {
    return (
        <>
          <button 
          type="button" 
          onClick={ toggleClientDropdown } 
          className={styles.dropdownButton}> { selectedClient } <FaChevronDown className={styles.icon} />  </button>  
        </>
      )
  }
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <form>
            <label>
              <span>Nome</span>
              <input
                type="text"
                required
                placeholder="Digite o nome do usuário"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </label>

            <label>
              <span>Login</span>
              <input
                type="text"
                required
                placeholder="Digite o login do usuário"
                value={ username }
                onChange={(e) => setUsername(e.target.value)}
              />
            </label>

            <label>
              <span>Senha</span>
              <input
                type="password"
                required
                placeholder="Digite a senha do usuário"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>

            <label>
              <span>Telefone</span>
              <input
                type="text"
                required
                placeholder="Digite o telefone do usuário"
                value={phone}
                onChange={ handlePhoneChange }
              />
            </label>

            <label>
              <span>Função do Usuário</span>
              <div className={styles.dropdown}>
                <button type="button" onClick={ toggleUserRoleDropdown } className={styles.dropdownButton}>
                  {selectedUserRole} <FaChevronDown className={styles.icon} />
                </button>
                { isUserRoleDropdownOpen && (
                  <div className={styles.dropdownContent}>
                    <div onClick={() => handleUserRoleSelect("Master/Admin")}>Master/Admin</div>
                  </div>
                )}
              </div>
            </label>

            <label>
              <span>Cliente</span>
                <div className={styles.dropdown}>
                { renderDropdown() }
                { isClientDropdownOpen ? (
                  <div className={styles.dropdownContent}>
                    {clients.map((client) => (
                      <div key={client.id} onClick={() => handleSelectClient(client)}>
                        {client.name}
                      </div>
                    ))}
                  </div>
                ): null}
              </div>
            </label>
          </form>
        </div>
        <div className={styles.buttonContent}>
          <button className={styles.buttonConfirm} onClick={ handleSaveUser }>Salvar Usuário</button>
          <button onClick={closeModal} className={styles.buttonCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
